import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThdAnalytics } from '@thd-olt-component-react/thd-analytics';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import { getRoutes } from './routes';
import { isLoggedIn } from './helpers';

ThdAnalytics.init();
NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext({
    opts: {
      federation: true,
    }
  });

  client.setExperienceRoutes(getRoutes());

  if (client.customer.type === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  } else {
    const isGuest = typeof window !== 'undefined' && !isLoggedIn();

    if (isGuest) {
      const signInURL = typeof window !== 'undefined'
      && `https://${window.location.hostname}/auth/view/signin?redirect=${encodeURIComponent(
        window.location.pathname + window.location.search,
      )}`;
      window.location.href = signInURL;
    } else {
      const redirectMyHomepageURL = typeof window !== 'undefined'
      && `https://${window.location.hostname}`;
      window.location.href = redirectMyHomepageURL;
    }
  }

  const customerType = client.customer.type || window.THDCustomer?.default.customerType || '';
  const customerRole = client.customer.role || window.THDCustomer?.default.role || '';
  const userId = client.customer.userId || window.THDCustomer?.default.userID || '';
  const svocId = client.customer.svocId || window.THDCustomer?.default.svocID || '';

  client.render(<App
    prefetchPip={client.featureSwitches.prefetchPip}
    productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
    customerType={customerType.toUpperCase()}
    customerRole={customerRole.toUpperCase()}
    userId={userId}
    svocId={svocId}
  />);
});